import React from 'react';
import { useTranslation } from 'react-i18next';
import { default as BaseButton } from '../../../BaseComponents/Button';
import { useTheme } from '../../../theme';
const LocationOptionsList = ({ options, renderGroup, renderOption, showButton, onButtonClick }) => {
    const { LocationOptionsList: css } = useTheme('LocationAutocomplete');
    const { t } = useTranslation('LocationAutocomplete');
    return (React.createElement("div", { className: css.locationOptionsList__wrapper },
        React.createElement("div", { className: css.locationOptionsList__list }, options.map((item, index) => ('value' in item ? renderOption(item, index) : renderGroup(item, index)))),
        showButton && !!onButtonClick && (React.createElement("div", { className: css.locationOptionsList__buttonWrapper },
            React.createElement(BaseButton, { variant: "smallThird", className: css.locationOptionsList__button, onMouseDown: onButtonClick }, t('show all directions'))))));
};
export default LocationOptionsList;
